export default __webpack_public_path__ + "static/photon_preview-91dac7ff6f2b68b5bcacec92dfacca02.png";